import {
  HasBluetoothPairingGuide,
  HasFamily,
  HasFamilyState,
  HasGroup,
  HasGroupState,
  HasPageUrl,
  HasSegmentType,
  HasSupportPageUrl,
} from '@gn-audio/jss-core';

import { ProductEntityType } from 'common/types/productTypes';

export type SearchUrlSuffixIndex = '' | 'suggest' | 'families' | 'groups';

export type SearchUrlSuffixName = 'Root' | 'Suggest' | 'Families' | 'Groups';

export const SearchUrlSuffix: Readonly<Record<SearchUrlSuffixName, SearchUrlSuffixIndex>> = {
  Families: 'families',
  Groups: 'groups',
  Root: '',
  Suggest: 'suggest',
};

export interface SearchParameters {
  filter?: string;
  includePrices?: boolean;
  marketLocale?: string;
  orderBy?: string;
  search?: string;
  skip?: number;
  top?: number;
}

export interface SearchSuggestParameters {
  filter?: string;
  marketLocale?: string;
  search?: string;
  top?: number;
}

export interface SearchItem
  extends HasBluetoothPairingGuide,
    HasFamily,
    HasFamilyState,
    HasGroup,
    HasGroupState,
    HasPageUrl,
    HasSupportPageUrl,
    HasSegmentType {
  attributes?: string[];
  discountedPrice?: number;
  discountedPriceWithoutVat?: number;
  familyName?: string;
  features?: string[];
  formattedDiscountedPrice?: string;
  formattedDiscountedPriceWithoutVat?: string;
  formattedListedPrice?: string;
  formattedListedPriceWithoutVat?: string;
  groupTitle?: string;
  isDiscounted?: boolean;
  images?: string[];
  itemType: ProductEntityType;
  listedPrice?: number;
  listedPriceWithoutVat?: number;
  marketLocale: string;
  sku?: string;
  summary?: string;
  title?: string;
  uniqueSellingPoint?: string;
}

export interface SearchResults<T> {
  count: number;
  items: T[];
}
